export enum PayerContractDocumentTypes {
    PRC = 1,  
    PPN = 2,
    NI = 3,
    VP = 4,
    MR = 5,
}
